import Bus from "../../utils/bus.js"
import api from '../../utils/api'

// import {Tooltip} from './tooltip/tooltip.es5'

var model = (function () {
    //let quality = 1
    let quality = 100;
    var sandbox,
        sandbox1,
        threeDModel, //3D模型
        fineModel, //精细模型
        has3DModel = false,
        textTagMarker
    var bool = true;
    var currentMarkerLists = [];
    let pt_position = '';
    let overhaul_tagMarker = null;
    var caseLists = {};
    var isOverhaul = false //判断是否在添加检修状态
    // 添加标注
    var hasMarker = false
    var cameraShow = true;
    var isConfirm = false //不可重复点击
    let sandboxCamera = null //标注时获取到的相机信息
    let isClick = null // 只要来控制是否为拖动
    let dataJson = {
        camera_lng: '',
        camera_lat: '',
        camera_height: '',
        camera_north: '',
        camera_tilt: '',
        outdoor_lng: '',
        outdoor_lat: '',
        outdoor_alt: '',
        indoor_camera_lat: '',
        indoor_camera_lng: '',
        indoor_lat: '',
        indoor_lng: ''
    };
    let imgList = [
        require('../images/normal/1.png'),
        require('../images/normal/2.png'),
        require('../images/normal/3.png'),
        require('../images/normal/4.png'),
        require('../images/normal/5.png'),
        require('../images/normal/6.png'),
        require('../images/normal/icon_point__maker.png'),
        require('../images/normal/icon_mod_bx.png')
    ];
    let z = -2;
    let timer = null;
    let loadingTag = null;
    let timer1 = null;
    let loadingTag1 = null;
    var polygons = []
    var tooltips = []
    
    Bus.$on('clear_polygons', () => {
        $('.tooltip').css({'visibility': 'hidden', 'top': '', 'left': ''})
        for (let j = 0; j < polygons.length; j ++) {
            polygons[j].opacity = 0
            polygons[j].visible = false;
        }
    })
    return {
        clearData: () => {
            // sandbox = null
            threeDModel = null //3D模型
            fineModel = null //精细模型
            has3DModel = false
            textTagMarker = null
            bool = true;
            currentMarkerLists = [];
            pt_position = '';
            overhaul_tagMarker = null;
            caseLists = {};
            isOverhaul = false //判断是否在添加检修状态
            // 添加标注
            hasMarker = false
            cameraShow = true;
            isConfirm = false //不可重复点击
            sandboxCamera = null //标注时获取到的相机信息
            dataJson = {
                camera_lng: '',
                camera_lat: '',
                camera_height: '',
                camera_north: '',
                camera_tilt: '',
                outdoor_lng: '',
                outdoor_lat: '',
                outdoor_alt: '',
                indoor_camera_lat: '',
                indoor_camera_lng: '',
                indoor_lat: '',
                indoor_lng: ''
            }
        },
        sandbox: null,
        // updateVisibility: () => {
        // 	sandbox.updateVisibility()
        // },
        //定义sandbox
        sandboxConfig: function (camera_attr) {
            console.log('sandboxConfig --------------- camera_attr ', camera_attr)
            const _this = this;
            return new Promise(function (resolve) {
                console.log('sandboxConfig --------------- 1 ', _this.sandbox)
                if (_this.sandbox) {
                    console.log('11111')
                    window.sandbox = _this.sandbox
                    _this.sandbox.camera.flyTo(camera_attr, 1000)
                    resolve(_this.sandbox);
                    return _this.sandbox
                } else {
                    console.log('22222')
                    if(navigator.userAgent.indexOf("iPad") != -1){
                        quality = 100;
                    }
                    api.getKey().then(res => {
                        let options = {
                            altizureApi: {
                                key: res.data.result.key, // 替换密钥
                            },
                            camera: {
                                poseTo: camera_attr,
                                flyTo: camera_attr
                            },
                            renderItems: {
                                earth: false,
                                earthUseTexture: false,
                                featureInView: false,
                                orbitRing: true,
                                quality: quality
                            }
                        }
                        sandbox = new altizure.Sandbox('page-content', options)
                        window.sandbox = sandbox
                        _this.sandbox = sandbox;
                        resolve(sandbox)
                    })
                }
            })
        },
        sandboxConfig1: function (camera_attr) {
            const _this = this;
            return new Promise(function (resolve) {
                if (_this.sandbox1 && _this.sandbox1.length > 0) {
                    window.sandbox1 = _this.sandbox1
                    resolve(_this.sandbox1);
                    return _this.sandbox1
                } else {
                    if(navigator.userAgent.indexOf("iPad") != -1){
                        quality = 100;
                    }
                    api.getKey().then(res => {
                        let options = {
                            altizureApi: {
                                key: res.data.result.key, // 替换密钥
                            },
                            camera: {
                                poseTo: camera_attr,
                                flyTo: camera_attr
                            },
                            renderItems: {
                                earth: false,
                                earthUseTexture: false,
                                featureInView: false,
                                orbitRing: true,
                                quality: quality
                            }
                        }
                        sandbox1 = new altizure.Sandbox('page-content1', options)
                        window.sandbox1 = sandbox1
                        _this.sandbox1 = sandbox1;
                        resolve(sandbox1)
                    })
                }
            })
        },
        //加载全景模型
        showImageModel: function(data, flag) {
            var that = this
            var isLoading = false
            caseLists = data
            var noWaterModel = null
            var check = new Promise(function(resolve, reject) {
                let cameraAttr = '';
                if (data.web_camera_attr.lng != '') {
                    cameraAttr = data.web_camera_attr;
                } else {
                    cameraAttr = data.camera_attr;
                }
                that.sandboxConfig(cameraAttr).then(function () {
                    that.sandbox.add('AltizureProjectMarker', {
                        pid: data.cid,
                        pose: {position: data.photo_attr},
                        visible: true
                    }).then(function (res) {
                        res.euler = {
                            lng: parseFloat(data.photo_attr.lng),
                            lat: parseFloat(data.photo_attr.lat),
                            alt: parseFloat(data.photo_attr.alt),
                            x: parseFloat(data.photo_attr.x),
                            y: parseFloat(data.photo_attr.y),
                            z: parseFloat(data.photo_attr.z),
                            scale: parseFloat(data.photo_attr.scale),
                            fixedSize: 50
                        }
                        res.scale = parseFloat(data.photo_attr.scale)

                        res.dim()
                        if (data.cid != data.vid) {
                            res.loadCropMask()
                        }
                        noWaterModel = res
                        return res.initialized
                    }).then((res) => {
                        return res.water.import()
                    }).then((res) => {
                        res.water.color = '#034F84'
                        res.water.wave = 10
                        res.water.speed = 0.5
                        resolve(res)
                        res = null
                    }).catch((error) => {
                        resolve(noWaterModel);
                        noWaterModel = null
                    })
                });
            });

            return new Promise(function(resolve, reject) {
                check && check.then((res) => {
                    console.log('res', res)
                    // sandbox.render(res, 'phong')
                    sandbox && (sandbox.lights.ambient.intensity = 0.01);
                    isLoading = true
                    threeDModel = res
                    if (flag == "index") {
                        let textTagMarker = {vector_attr:{lng: 114.09077616990449, lat: 22.546082616094992, alt: 0}}
                        that.addIndexTextTagMarker(textTagMarker, '工会大厦')
                    }
                    that.hideLoadingPic(res);
                    resolve(res)
                })
            })
        },
        //加载全景模型
        showImageModel1: function (data, flag) {
            var that = this
            caseLists = data

            return new Promise(function (resolve) {
                that.sandboxConfig1(data.camera_attr).then(function () {
                    that.addLoadingPic1(data.camera_attr);
                    that.sandbox1 && that.sandbox1.add('AltizureProjectMarker', {
                        pid: data.cid,
                        pose: {
                            position: data.photo_attr
                        },
                        visible: true,
                        interactable: true
                    }).then(function (res) {
                        res.euler = {
                            lng: parseFloat(data.photo_attr.lng),
                            lat: parseFloat(data.photo_attr.lat),
                            alt: parseFloat(data.photo_attr.alt),
                            x: parseFloat(data.photo_attr.x),
                            y: parseFloat(data.photo_attr.y),
                            z: parseFloat(data.photo_attr.z),
                            scale: parseFloat(data.photo_attr.scale),
                            fixedSize: 50
                        }
                        res.scale = parseFloat(data.photo_attr.scale)
                        res.dim();
                        res.loadCropMask()
                        return res.initialized
                    }).then((res) => {
                        // sandbox.render(res, 'phong')
                        sandbox1 && (sandbox1.lights.ambient.intensity = 0.01);
                        threeDModel = res
                        if (flag == "index") {
                            // document.getElementById('page-content1').addEventListener("click", function (event) {
                            //     var pt = sandbox1.pickOnProjects(event);
                            //     if (!pt) {
                            //         return;
                            //     }
                            //     sandbox1.on('cameraChange', function () {
                            //         console.log('sandboxCamera1', sandbox1.camera.pose)
                            //     });
                            //     console.log('sandbox1===', pt)
                            // });
                            let textTagMarker = {vector_attr:{lng: 113.91137157964494, lat: 22.493209978680678, alt: 0}}
                            that.addIndexTextTagMarker1(textTagMarker, '深圳自贸中心')
                        }
                        that.hideLoadingPic1(res);
                        resolve(res)
                    });
                })
            })
        },
        //加载精细模型
        make3DModel: function (data, init = 0) {
            var that = this
            var isLoading = false
            return new Promise(function (resolve) {
                console.log(data.vid)
                var vectorCameraAttr = '';
                if (data.web_vector_camera_attr.lng != '') {
                    vectorCameraAttr = data.web_vector_camera_attr
                } else {
                    vectorCameraAttr = data.vector_camera_attr
                }
                if (init == 1) {
                    that.sandboxConfig(data.vetor_camera_attr).then(function () {
                        sandbox && sandbox.add('AltizureProjectMarker', {
                            pid: data.vid,
                            pose: {
                                position: data.vector_attr
                            },
                            visible: true,
                            scale: parseFloat(data.vector_attr.scale)
                        }).then(function (res) {
                            var fineModel = res;
                            fineModel.euler = {
                                lng: data.vector_attr.lng,
                                lat: data.vector_attr.lat,
                                alt: data.vector_attr.alt,
                                x: data.vector_attr.x,
                                y: data.vector_attr.y,
                                z: data.vector_attr.z,
                                scale: parseFloat(data.vector_attr.scale),
                                fixedSize: 50
                            }
                            return fineModel.initialized
                        }).then(function (res) {
                            fineModel = res
                            fineModel.dim()
                            isLoading = true
                            console.log("触发中")
                            resolve(fineModel)
                        })
                    });
                } else {
// 					console.log(data.vid)
// 					console.log(window.vid)
                    sandbox && sandbox.add('AltizureProjectMarker', {
                        pid: data.vid,
                        pose: {
                            position: data.vector_attr
                        },
                        visible: true,
                        scale: parseFloat(data.vector_attr.scale)
                    }).then(function (res) {
                        console.log('init = 0 ',res)
                        var fineModel = res;
                        fineModel.euler = {
                            lng: data.vector_attr.lng,
                            lat: data.vector_attr.lat,
                            alt: data.vector_attr.alt,
                            x: data.vector_attr.x,
                            y: data.vector_attr.y,
                            z: data.vector_attr.z,
                            scale: parseFloat(data.vector_attr.scale),
                            fixedSize: 50
                        }
                        return fineModel.initialized
                    }).then(function (res) {
                        fineModel = res
                        fineModel.dim()
                        isLoading = true
                        // $('#loading1-div').remove()
                        // window.get_loading.remove_loading()
                        if (textTagMarker) {
                            textTagMarker.visible = false
                        }
                        resolve(fineModel)
                    })
                }

            })
        },
        //添加textTagMarker
        addTextTagMarker: function (altmarker, data, name) {
            const _this = this
            return new Promise(function (resolve) {
                // let getAlt = altmarker.pickDepthMap([{lng: parseFloat(data.photo_attr.lng), lat: parseFloat(data.photo_attr.lat)}])
                // let alt = parseFloat(getAlt[0].replace('NaN', '')) * 10000
                textTagMarker = new altizure.TextTagMarker({
                    text: name,
                    textStyle: {
                        fillStyle: 'rgb(245, 198, 35)',
                        font: 'normal 500 24px SimHei',
                        outlineWidth: 5,
                        outlineStyle: 'rgb(0, 0, 0)'
                    },
                    position: {
                        lng: data.vector_attr.lng,
                        lat: data.vector_attr.lat,
                        alt: parseFloat(data.vector_attr.alt) + 100
                    },
                    sandbox: sandbox,
                    scale: 1,
                    pinLength: 230
                })

                resolve(textTagMarker)
            })
        },
        addIndexTextTagMarker: function (data, name) {
            const _this = this
            return new Promise(function (resolve) {
                // let getAlt = altmarker.pickDepthMap([{lng: parseFloat(data.photo_attr.lng), lat: parseFloat(data.photo_attr.lat)}])
                // let alt = parseFloat(getAlt[0].replace('NaN', '')) * 10000
                textTagMarker = new altizure.TextTagMarker({
                    text: name,
                    textStyle: {
                        fillStyle: 'rgb(245, 198, 35)',
                        font: 'normal 500 24px SimHei',
                        outlineWidth: 5,
                        outlineStyle: 'rgb(0, 0, 0)'
                    },
                    position: {
                        lng: data.vector_attr.lng,
                        lat: data.vector_attr.lat,
                        alt: parseFloat(data.vector_attr.alt) + 100
                    },
                    sandbox: sandbox,
                    scale: 1,
                    pinLength: 50,
                    fixedSize: 100
                })

                resolve(textTagMarker)
            })
        },
        addIndexTextTagMarker1: function (data, name) {
            const _this = this
            return new Promise(function (resolve) {
                // let getAlt = altmarker.pickDepthMap([{lng: parseFloat(data.photo_attr.lng), lat: parseFloat(data.photo_attr.lat)}])
                // let alt = parseFloat(getAlt[0].replace('NaN', '')) * 10000
                textTagMarker = new altizure.TextTagMarker({
                    text: name,
                    textStyle: {
                        fillStyle: 'rgb(245, 198, 35)',
                        font: 'normal 500 24px SimHei',
                        outlineWidth: 5,
                        outlineStyle: 'rgb(0, 0, 0)'
                    },
                    position: {
                        lng: data.vector_attr.lng,
                        lat: data.vector_attr.lat,
                        alt: parseFloat(data.vector_attr.alt) + 100
                    },
                    sandbox: sandbox1,
                    scale: 1,
                    pinLength: 200,
                    fixedSize: 100
                })

                resolve(textTagMarker)
            })
        },
        //添加TagMarker （气泡）
        addTagMarker: function (pt, riskType, isShowTag, url) { //添加tagMarker,
            return new Promise(function (resolve) {
                function Debounce(func, delay) {
                    let timer
                    return function () {
                        clearTimeout(timer)
                        timer = setTimeout(function () {
                            if (func) func()
                        }, delay)
                    }
                }

                window.addEventListener("mouseup", function (event) {
                    isClick = false
                }, false);
                window.addEventListener("mousedown", function (event) {
                    isClick = true
                }, false);

                window.addEventListener("touchend", function (event) {
                    isClick = false
                }, false);
                window.addEventListener("touchstart", function (event) {
                    isClick = true
                }, false);
                let updatePositionDebounce = Debounce(updatePosition, 100)
                console.log('this is updatePosition pt ', pt)
                sandbox && sandbox.on('cameraChange', function () {
                    if (isClick) {
                        updatePosition()
                    } else {
                        updatePositionDebounce()
                    }
                })

                function updatePosition() {
                    // transforms from earth-space position {lng, lat, alt} to screen-space {x, y}
                    // sandbox.updateVisibility()
                    let screenPosition = sandbox && sandbox.window.fromLngLatAlt(pt)
                    //screenPosition && !isOverhaul && currentMarkerLists.length
                    if (screenPosition && currentMarkerLists.length) {
                        let left = screenPosition.x - 170,
                            top = 0
                        // if (left < 400) { // 如果left 小于400的话代表没把左边的弹窗算起来，这个时候要加上400
                        // 	left += 400
                        // 	top = $('canvas').offset().top - $('.header')[0].clientHeight
                        // }

                        $(".pinDiv").css({
                            'top': screenPosition.y - 50 + 'px',
                            'left': screenPosition.x - 120 + 'px'
                        })
                    }
                }

                let imgUrl = imgList[riskType];
                if (riskType == "icon_mod_bx") {
                    imgUrl = imgList[6];
                }
                var tagMarker = new altizure.TagMarker({
                    imgUrl: imgUrl,
                    // imgUrl: 'http://' + host + '/public/assets/img/tag/normal/' + riskType + '.png',
                    position: pt,
                    sandbox: sandbox,
                    visible: isShowTag,
                    scale: 1,
                    pivot: {
                        x: 0.5,
                        y: 0
                    },
                    fixedSize: 100
                })
                // var scale = Math.sqrt(0.00025 * Math.max(100, sandbox.camera.pose.alt))
                // tagMarker.scale = fineModel ? scale : 0.1
                resolve(tagMarker)
            })
        },
        //添加ProjectMarker （小圆点）
        addProjectMarker: function (pt, tabIndex, index, is) {
            const _this = this;
            return new Promise(function (resolve) {
                var pids = {
                    1: {
                        pid: 'http://img.smartfacade.com.cn/3D/public/img/icon/1.png'
                    },
                    2: {
                        pid: 'http://img.smartfacade.com.cn/3D/public/img/icon/2.png'
                    },
                    3: {
                        pid: 'http://img.smartfacade.com.cn/3D/public/img/icon/3.png'
                    },
                    4: {
                        pid: 'http://img.smartfacade.com.cn/3D/public/img/icon/4.png'
                    },
                    5: {
                        pid: 'http://img.smartfacade.com.cn/3D/public/img/icon/5.png'
                    },
                    6: {
                        pid: 'http://img.smartfacade.com.cn/3D/public/img/icon/6.png'
                    }
                }
                var projectMarker = new altizure.TagMarker({
                    imgUrl: pids[tabIndex + 1].pid,
                    // imgUrl: 'http://' + host + '/public/assets/img/tag/normal/' + riskType + '.png',
                    position: pt,
                    sandbox: sandbox,
                    visible: is,
                    scale: 1,
                    pivot: {
                        x: 0.5,
                        y: 0
                    },
                    fixedSize: 20
                })

                projectMarker.interactable = true
                projectMarker.on('click', function (e) {
                    Bus.$emit('chooseTab_member', index)
                })
                resolve(projectMarker)
            })
        },
        //添加marker projectmarker
        showChoosedPoint: function (lists, tabIndex, currentIndex, url) {
            var lists = JSON.parse(JSON.stringify(lists))
            var that = this
            return new Promise(function (resolve) {
                var marker = {}
                var pt = lists[currentIndex].outdoor_position
                console.log(lists[currentIndex].level)
                var tagType = lists[currentIndex].level === 1 ? (parseInt(tabIndex) + 1) : tabIndex
                //添加tagMarker 只存在一个tagMarker
                that.addTagMarker(pt, tagType, true, url).then(function (tag) {
                    marker.tag = tag
                })
                marker.project = []
                lists.map(function (item, index) {
                    if (Object.keys(item.outdoor_position).length) {
                        var pt = that.extractObj(item.outdoor_position)
                        //添加ProjectMarker
                        let proType = item.level === 1 ? (parseInt(tabIndex) + 1) : tabIndex
                        that.addProjectMarker(pt, proType, index, currentIndex != index).then(project => {
                            marker.project[index] = project
                        })
                    }
                })
                resolve(marker)
            })
        },
        //标记全部销毁
        clearTagMarkerListsVisible: function (list) {
            console.log(list)
            list = list || currentMarkerLists
            console.log('clearTagMarkerListsVisible list ', list)
            return list.map(function (item) {
                console.log('444444444 item' , item)
                if (item.tag.parent) {
                    item.tag.destruct()
                }
                if (item.project) {
                    item.project.map(function (project) {
                        // console.log('33333333333333 project ', project)
                        //清除project 事件
                        if (project.parent) {
                            project.off('click')
                            project.destruct()
                        }
                    })
                }
            })
        },
        cancel: function () {
            $(".add_repair").hide();
            cameraShow = false;
            hasMarker = false;
            isOverhaul = false;
            has3DModel = false;
            if (overhaul_tagMarker) {
                overhaul_tagMarker.destruct()
                overhaul_tagMarker = null
            }

            // if (fineModel) {
            //     fineModel.destruct()
            //     fineModel = null
            // }
            if (textTagMarker) {
                textTagMarker.visible = false;
            }
        },
        addMarker: function () {
            hasMarker = true
            cameraShow = true
        },
        switchLiveAction: function () {
            console.log('switchLiveAction ---- ')
            // for (let j = 0; j < polygons.length; j ++) {
            //     polygons[j].interactable = false;
            //     polygons[j].opacity = 0
            //     polygons[j].visible = false;
            // }
            if (!threeDModel) {
                // window.get_loading.remove_loading()
                window.get_loading.loading()
            }
            let tempTimer = setInterval(function () {
                if (fineModel) {
                    fineModel.visible = false
                    clearInterval(tempTimer)
                }
            }, 10)
            return new Promise(resolve => {
                // sandbox && sandbox.camera.flyTo(this.extractObj(caseLists.camera_attr), 100)
                // console.log('11111111111111111 caseLists ', caseLists)
                if (caseLists && caseLists.web_mat && caseLists.web_mat.length) {
                    this.flyToMat(caseLists.web_mat)
                } else {
                    let camera_attr = null
                    if (caseLists.web_camera_attr && caseLists.web_camera_attr.lat) {
                        camera_attr = caseLists.web_camera_attr
                    } else {
                        camera_attr = caseLists.camera_attr
                    }
                    // sandbox && sandbox.camera.flyTo(this.extractObj(camera_attr), 100)
                    this.flyToPosition(this.extractObj(camera_attr), 100)
                }

                
                // sandbox && sandbox.camera.flyTo(this.extractObj(caseLists.web_camera_attr), 100)
                if (!has3DModel) {
                    has3DModel = false;
                    if (threeDModel) {
                        threeDModel.visible = true
                    }
                    if (fineModel) {
                        fineModel.visible = false
                    }
                    //全景模型销毁所有标注
                    currentMarkerLists = this.clearTagMarkerListsVisible(currentMarkerLists)
                    currentMarkerLists = []
                    $('.pinDiv').hide()
                    //clearTagMarkerListsVisible()
                }
                if (textTagMarker) {
                    textTagMarker.visible = true;
                }
                resolve(fineModel)
            })

        },
        switchThree3D: function () {
            console.log('switchThree3D ---- ')
            // for (let j = 0; j < polygons.length; j ++) {
            //     polygons[j].interactable = true;
            //     polygons[j].opacity = 0
            //     polygons[j].visible = false;
            // }
            if (tempTimer) {
                clearInterval(tempTimer)
            }
            if (!fineModel) {
                // window.get_loading.remove_loading()
                window.get_loading.loading()
            }
            let tempTimer = setInterval(function () {
                if (threeDModel) {
                    threeDModel.visible = false
                    clearInterval(tempTimer)
                }
            }, 10)

            return new Promise(resolve => {
                // sandbox && sandbox.camera.flyTo(this.extractObj(caseLists.vetor_camera_attr), 100)
                console.log('0000000000000 caseLists ', caseLists)
                if (caseLists && caseLists.web_vector_mat && caseLists.web_vector_mat.length) {
                    this.flyToMat(caseLists.web_vector_mat)
                } else {
                    let camera_attr = null
                    if (caseLists.web_vector_camera_attr && caseLists.web_vector_camera_attr.lat) {
                        camera_attr = caseLists.web_vector_camera_attr
                    } else {
                        camera_attr = caseLists.vetor_camera_attr
                    }
                    // sandbox && sandbox.camera.flyTo(this.extractObj(camera_attr), 100)
                    this.flyToPosition(this.extractObj(camera_attr), 100)
                }
                
                if (threeDModel) {
                    threeDModel.visible = false
                }
                if (textTagMarker) {
                    textTagMarker.visible = false
// 						textTagMarker.pinLength = 0
// 						textTagMarker.scale = 0
                }
                if (fineModel) {
                    fineModel.visible = true
                    resolve(fineModel)
                } else {
                    //加载精细模型
                    fineModel = null;
                    model.make3DModel(caseLists).then(function (res) {
                        sandbox.on("cameraChange", function(e) {
                            for (let k = 0; k < tooltips.length; k ++) {
                                tooltips[k].hide()
                            }
                            for (let j = 0; j < polygons.length; j ++) {
                                polygons[j].opacity = 0
                                polygons[j].visible = false;
                            }
                            // console.log(sandbox.camera.mat)
                        })
                        $.ajax({
                            url: "https://api.smartfacade.com.cn/admin/building/floor/getPolygons",
                            data: JSON.stringify({building_id: caseLists.building_id}),
                            type: "post",
                            dataType: "json",
                            cache: false,
                            contentType: false,
                            processData: false,
                            success: function (res) {
                                console.log('model.make3DModel ========== res ', res)
                                if (res.code === 200 && res.result.length > 0) {
                                    for (let i = 0; i < res.result.length; i++) {
                                        let polygon = new altizure.PolygonMarker({
                                            name: i + 1,
                                            sandbox: sandbox,
                                            volume: {
                                                points: res.result[i].points.map(function(lnglat) {
                                                    return new altizure.LngLatAlt(
                                                        lnglat.lng,
                                                        lnglat.lat,
                                                        lnglat.alt
                                                    );
                                                }),
                                                top: parseInt(res.result[i].top),
                                                bottom: parseInt(res.result[i].bottom),
                                                color: res.result[i].color,
                                                opacity: 0
                                            },
                                            visible: false,
                                            interactable: true
                                        });
                                        polygon.info = res.info
                                        polygons.push(polygon)
                                        let tooltip = new Tooltip({ content:  res.result[i].info.area + " " + res.result[i].info.floor })
                                        tooltips.push(tooltip)
                                        polygon.on("click", function(event) {
                                            console.log('tool tip event ====  ', event)
                                            for (let j = 0; j < polygons.length; j ++) {
                                                polygons[j].opacity = 0
                                                if (polygons[j] != polygon) {
                                                    polygons[j].visible = false
                                                }
                                            }
                                            for (let k = 0; k < tooltips.length; k ++) {
                                                tooltips[k].hide()
                                            }
                                            polygon.visible = true
                                            polygon.opacity = 0
                                            tooltip.show(event)
                                        });


                                    }
                                }
                            }
                        });
                        // $('#loading1-div').remove()
                        // $('#reload1').show()
                        // window.get_loading.remove_loading()
                        fineModel = res
                        fineModel.visible = true
                        resolve(fineModel)
                    })
                }
                // resolve()
            })
        },
        addOverhaul: function () {
            // destructDeport(function () {
            //切换类别销毁所有标注
            return new Promise(resolve => {
                currentMarkerLists = this.clearTagMarkerListsVisible(currentMarkerLists)
                currentMarkerLists = []
                isOverhaul = true
                // sandbox && sandbox.camera.flyTo(this.extractObj(caseLists.vetor_camera_attr), 100)
                this.flyToPosition(this.extractObj(caseLists.vetor_camera_attr), 100)
                
                threeDModel.visible = false
                if (textTagMarker) {
                    textTagMarker.visible = false
// 						textTagMarker.pinLength = 0
// 						textTagMarker.scale = 0
                }
                if (fineModel) {
                    fineModel.visible = true
                    resolve(res)
                    return
                } else {
                    window.get_loading.loading();
                    //加载精细模型
                    model.make3DModel(caseLists).then(function (res) {
                        $.ajax({
                            url: "https://api.smartfacade.com.cn/admin/building/floor/getPolygons",
                            data: JSON.stringify({building_id: caseLists.building_id}),
                            type: "post",
                            dataType: "json",
                            cache: false,
                            contentType: false,
                            processData: false,
                            success: function (res) {
                                if (res.code === 200 && res.result.length > 0) {
                                    for (let i = 0; i < res.result.length; i++) {
                                        let polygon = new altizure.PolygonMarker({
                                            name: i + 1,
                                            sandbox: sandbox,
                                            volume: {
                                                points: res.result[i].points.map(function(lnglat) {
                                                    return new altizure.LngLatAlt(
                                                        lnglat.lng,
                                                        lnglat.lat,
                                                        lnglat.alt
                                                    );
                                                }),
                                                top: parseInt(res.result[i].top),
                                                bottom: parseInt(res.result[i].bottom),
                                                color: res.result[i].color,
                                                opacity: 0
                                            },
                                            visible: false,
                                            interactable: true
                                        });
                                        polygon.info = res.info
                                        polygons.push(polygon)
                                        let tooltip = new Tooltip({ content:  res.result[i].info.area + " " + res.result[i].info.floor })
                                        tooltips.push(tooltip)
                                        polygon.on("click", function(event) {
                                            for (let j = 0; j < polygons.length; j ++) {
                                                polygons[j].opacity = 0
                                                polygons[j].visible = false
                                            }
                                            for (let k = 0; k < tooltips.length; k ++) {
                                                tooltips[k].hide()
                                            }
                                            polygon.visible = true
                                            polygon.opacity = 0
                                            tooltip.show(event)
                                        });
            
            
                                    }
                                }
                            }
                        });
                        // $('#loading1-div').remove()
                        // $('#reload1').show()
                        // window.get_loading.remove_loading()
                        fineModel = res
                        fineModel.visible = true
                        resolve(res)
                    })
                }
                // resolve()
            })

        },
        listenCamera: function () {
            const _this = this;
            return new Promise(resolve => {
                sandbox && sandbox.on("cameraChange", function (e) {
                    // sandbox.updateVisibility()
                    if (!threeDModel || !threeDModel.visible) {
                        if (textTagMarker) {
                            textTagMarker.visible = false;
// 							textTagMarker.pinLength = 0
// 							textTagMarker.scale = 0
                        }
                        return false;
                    }
                    if (isOverhaul) return false;
                    let currentAlt = sandbox.camera.pose.alt
                    if (textTagMarker != null) {
                        textTagMarker.scale = 0.003 * currentAlt;
                        if (0.25 * currentAlt < 230) {
                            textTagMarker.pinLength = 230;
                        } else {
                            textTagMarker.pinLength = 0.25 * currentAlt;
                        }
                    }

                    // 	if (Number(currentAlt.toFixed(4)) < Number(res.height).toFixed(4)) {
                    // 		if (!has3DModel && bool) {
                    // 			bool = false
                    // 			var openFineModel = function() {
                    // 				has3DModel = true
                    // 				threeDModel.visible = false
                    // 				fineModel.visible = true
                    // 				openFineModel = null;
                    // 				bool = true
                    // 			}
                    // 			if (fineModel) {
                    // 				openFineModel()
                    // 			} else {
                    // 				//get_loading.loading2()
                    // 				$(".el-loading-mask").css({
                    // 					'display':'block'
                    // 				})
                    // 				$(".el-loading-mask .el-loading-text").text('加载精细模型中');
                    // 				_this.make3DModel(res).then(function(res) {
                    // 					fineModel = res;
                    // 					//textTagMarker 隐藏
                    // 					if (textTagMarker) {
                    // 						textTagMarker.visible = false
                    // 						textTagMarker.pinLength = 0
                    // 						textTagMarker.scale = 0
                    // 					};

                    // 					$(".el-loading-mask").css({
                    // 						'display':'none'
                    // 					});
                    // 					openFineModel()
                    // 					//get_loading.remove_loading2()
                    // 				})
                    // 			}
                    // 		}
                    // 		if (textTagMarker) {
                    // 			textTagMarker.visible = false;
                    // 		}
                    // 	} else {

                    // 		if (has3DModel) {
                    // 			has3DModel = false;
                    // 			threeDModel.visible = true
                    // 			fineModel.visible = false
                    // 			//全景模型销毁所有标注
                    // 			currentMarkerLists = _this.clearTagMarkerListsVisible(currentMarkerLists)
                    // 			currentMarkerLists = []
                    // 			$('.pinDiv').hide()
                    // 			//clearTagMarkerListsVisible()
                    // 		}
                    // 		if (textTagMarker) {
                    // 			textTagMarker.visible = true;
                    // 		}
                    // 	}
                    resolve()
                })
            })
        },
        /*飞行*/
        cameraLoop: function (res, idx, currentIndex) {
            console.log('cameraLoop res ', res)
            let that = this;
            console.log('cameraLoop res  0000 ',res[currentIndex]);
            return new Promise(resolve => {
                if (res[currentIndex].outdoor_position.lat && res[currentIndex].outdoor_position.lng) {
                    // sandbox && sandbox.camera.flyTo(this.extractObj(res[currentIndex].camera), 2000);

                    this.flyToPosition(this.extractObj(res[currentIndex].camera), 2000)
                    that.addChoosedPoint(res, idx, currentIndex)
                    
                }
                resolve()
            })

        },
        /*添加标注点*/
        addChoosedPoint: function (lists, tabIndex, currentIndex) {

            //判断是否有标注点 ，只存在一个tabIndex标注 ，切换类别销毁与清除事件
            var tagType = lists[currentIndex].level === 1 ? (parseInt(tabIndex) + 1) : tabIndex
            if (currentMarkerLists[tabIndex] && tabIndex < 4) {
                var pt = this.extractObj(lists[currentIndex].outdoor_position)
                //切换小卡片只改变tagMarker的position
                // debugger
                // currentMarkerLists[tabIndex].tag.position = pt
                // Object.assign(currentMarkerLists[tabIndex].tag.position, pt)
                if (currentMarkerLists[tabIndex].tag.parent) {
                    currentMarkerLists[tabIndex].tag.position = pt
                }
                currentMarkerLists[tabIndex].project.map(function (item, index) {
                    if (index == currentIndex) {
                        currentMarkerLists[tabIndex].project[index].visible = false
                    } else {
                        currentMarkerLists[tabIndex].project[index].visible = true
                    }
                })
                return
            } else {
                //切换类别销毁所有标注
                currentMarkerLists = this.clearTagMarkerListsVisible(currentMarkerLists)
                currentMarkerLists = []
            }
            //添加标注点
            this.showChoosedPoint(lists, tabIndex, currentIndex, '..').then(function (res) {
                console.log('this is show choose point res ', res)
                currentMarkerLists[tabIndex] = res;
            })
        },
        hiddenTagMarker() {
            currentMarkerLists.forEach( item => {
                item.project.forEach( (item1) => {
                    item1.visible = false
                    item1.interactable = false
                })
                if (item.tag) {
                    item.tag.interactable = false
                    item.tag.visible = false
                }
            })
        },
        //控制 Polygons 显示隐藏
        controlPolygons(status) {
            for (let j = 0; j < polygons.length; j ++) {
                polygons[j].interactable = status;
                polygons[j].opacity = 0
                polygons[j].visible = false;
            }
            
        },
        showTagMarker() {
            currentMarkerLists.forEach( item => {
                item.project.forEach( (item1) => {
                    item1.interactable = true
                })
                if (item.tag) {
                    item.tag.interactable = true
                    item.tag.visible = true
                }
            })
        },
        clearTagMarker() {
            currentMarkerLists.forEach( item => {
                item.project.forEach( (item1) => {
                    item1.visible = false
                    item1.destruct()
                    item1 = null
                })
                if (item.tag) {
                    item.tag.visible = false
                    item.tag.destruct()
                    item.tag = null
                }
            })
        },
        extractObj: function (str) {
            var res = str
            // if (res) {
            //     res = JSON.parse(str);
            // }
            res.alt = parseFloat(res.alt);
            // res.lat2 = res.lat;
            res.lat = parseFloat(res.lat);
            res.lng = parseFloat(res.lng);
            if (res.north) {
                res.north = parseFloat(res.north);
            }
            if (res.tilt) {
                res.tilt = parseFloat(res.tilt);
            }
            return res;
        },
        onMouseUp: function (event) {
            if (!sandbox) {return}
            if (!hasMarker) {
                return
            }
            let pt = sandbox.pickOnProjects(event)
            if (!pt) {
                return
            }
            if (overhaul_tagMarker) {
                overhaul_tagMarker.destruct()
                overhaul_tagMarker = null
            }
            dataJson.outdoor_lng = pt.lng.toPrecision(9);
            dataJson.outdoor_lat = pt.lat.toPrecision(9);
            dataJson.outdoor_alt = pt.alt.toPrecision(7);
            sandboxCamera = sandbox.camera.pose;

            if (overhaul_tagMarker != null) {
                overhaul_tagMarker.position = {
                    lng: dataJson.outdoor_lng,
                    lat: dataJson.outdoor_lat,
                    alt: dataJson.outdoor_alt
                };
            } else {
                overhaul_tagMarker = new altizure.TagMarker({
                    imgUrl: imgList[6],
                    position: {lng: dataJson.outdoor_lng, lat: dataJson.outdoor_lat, alt: dataJson.outdoor_alt},
                    sandbox: sandbox,
                    visible: true,
                    scale: 1,
                    pivot: {x: 0.5, y: 0},
                    fixedSize: 100 // icon size
                })
            }
            Position();
            sandbox.on('cameraChange', function () {
                // transforms from earth-space position {lng, lat, alt} to screen-space {x, y}
                // sandbox.updateVisibility()
                let screenPosition = sandbox.window.fromLngLatAlt(pt)
                if (screenPosition) {
                    if (!cameraShow) return false;
                    console.log("显示窗口")
                    $(".add_repair").css({
                        'display': 'block',
                        'top': screenPosition.y - 33 + 'px',
                        'left': screenPosition.x + 18 + 'px'
                    })

                }
            });

            function Position() {
                if (!sandbox) {return}
                // transforms from earth-space position {lng, lat, alt} to screen-space {x, y}
                let screenPosition = sandbox.window.fromLngLatAlt(pt)

                if (screenPosition) {
                    if (!cameraShow) return false;
                    console.log("显示窗口")
                    $(".add_repair").css({
                        'display': 'block',
                        'top': screenPosition.y - 33 + 'px',
                        'left': screenPosition.x + 18 + 'px'
                    })

                }
            }

            hasMarker = false;
        },
        confirm: function () {
            return new Promise(resolve => {
                // 确定按钮
                let pose = sandboxCamera;
                dataJson.camera_lng = pose.lng;
                dataJson.camera_lat = pose.lat;
                dataJson.camera_height = pose.alt;
                dataJson.camera_north = pose.north;
                dataJson.camera_tilt = pose.tilt;
                resolve(dataJson)
            })
        },
        getScreenshot() {
            return new Promise(resolve => {
                var rgbresult
                var img = new Image()
                var downloadcanvas = document.createElement('canvas')
                var downloadcanvasDataURL
                rgbresult = sandbox && sandbox.window.screenshot()
                // parse data to canvas and data url
                var ctx = downloadcanvas.getContext('2d')
                ctx.clearRect(0, 0, downloadcanvas.width, downloadcanvas.height)
                downloadcanvas.width = rgbresult.width
                downloadcanvas.height = rgbresult.height
                var rgbimdata = ctx.createImageData(rgbresult.width, rgbresult.height)
                for (let i = 0; i < rgbimdata.data.length; ++i) {
                    rgbimdata.data[i] = rgbresult.data[i]
                }
                ctx.putImageData(rgbimdata, 0, 0)
                downloadcanvasDataURL = downloadcanvas.toDataURL("image/png")
                let user_id = JSON.stringify(localStorage.getItem('user_info')).id

                let buildJson = localStorage.getItem('buildJson')
                let project_id = buildJson && JSON.parse(buildJson).id;
                let data = JSON.stringify({
                    project_id: project_id,
                    user_id: user_id,
                    screen_shot: downloadcanvasDataURL
                })
                $.ajax({
                    url: api.baseUrlApi() + "/project/uploadScreenShot",
                    type: 'POST',
                    dataType: 'json',
                    data: data,
                    success: function (ret) {
                        resolve(ret.result.image_id)
                    }
                })
            })
        },
        building: function (res, vetor_camera_attr, params) {
            if (!sandbox) {return}
            sandbox.camera.flyTo(this.extractObj(vetor_camera_attr), 200)
            fineModel = res
            fineModel.visible = true
            if (params.position) {
                if (params.position.outdoor_alt && params.position.outdoor_alt != 'null') {
                    sandbox.camera.flyTo({
                        alt: params.position.camera_height,
                        lat: params.position.camera_lat,
                        lng: params.position.camera_lng,
                        north: params.position.camera_north,
                        tilt: params.position.camera_tilt
                    }, 2000)
                }
                if (params.position.outdoor_lng && params.position.outdoor_lng != 'null') {
                    let pt = {
                        lng: params.position.outdoor_lng,
                        lat: params.position.outdoor_lat,
                        alt: params.position.outdoor_alt
                    }
                    model.addTagMarker(pt, 'icon_mod_bx', true).then(function (tag) {
                        $(".pinDiv").remove()
                        overhaul_tagMarker = tag
                    })
                }
            }

        },
        addLoadingPic: function (position) {
            if (!sandbox) {return}
            loadingTag = new altizure.TagMarker({
                imgUrl: 'http://img.smartfacade.com.cn/loading_pic.png',
                // icon position
                position: {lng: position.lng, lat: position.lat, alt: 0},
                // scene
                sandbox: sandbox,
                scale: 20,
                isSprite: false,
                tagQuaternion: {x: 0, y: 0, z: z, order: 'XYZ', isEuler: true}
            });
            timer = setInterval(function () {
                z += 0.08
                loadingTag.tagQuaternion = {x: 0, y: 0, z: z, order: 'XYZ', isEuler: true}
            }, 10)
        },
        addLoadingPic1: function (position) {
            if (!sandbox1) {return}
            loadingTag1 = new altizure.TagMarker({
                imgUrl: 'http://img.smartfacade.com.cn/loading_pic.png',
                // icon position
                position: {lng: position.lng, lat: position.lat, alt: 0},
                // scene
                sandbox: sandbox1,
                scale: 20,
                isSprite: false,
                tagQuaternion: {x: 0, y: 0, z: z, order: 'XYZ', isEuler: true}
            });
            timer1 = setInterval(function () {
                z += 0.08
                loadingTag1.tagQuaternion = {x: 0, y: 0, z: z, order: 'XYZ', isEuler: true}
            }, 10)
        },
        hideLoadingPic: function () {
            if (loadingTag && timer) {
                loadingTag.destruct();
                loadingTag = null;
                clearInterval(timer)
                timer = null;
            }
        },
        hideLoadingPic1: function () {
            if (loadingTag1 && timer1) {
                loadingTag1.destruct();
                loadingTag1 = null;
                clearInterval(timer1)
                timer1 = null;
            }
        },
        renderSlide: function (activeState, currentIndex) {

        },
        flyToPosition(camera_attr, time) {
            time = time || 2000
            console.log('flyToPosition camera_attr ', camera_attr)
            if (sandbox && camera_attr && camera_attr.lat) {
                sandbox.camera.flyTo(camera_attr, time)
            }
        },
        flyToMat(camera_mat) {
            if (sandbox && camera_mat && camera_mat.length) {
                sandbox.camera.flyToMat(camera_mat, 2000)
            }
        },
    }
})()

export default model



// WEBPACK FOOTER //
// ./src/assets/js/model.js